'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ModalContainer = require('../../lib/ModalContainer');

var _ModalContainer2 = _interopRequireDefault(_ModalContainer);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = require('merge-theme-hoc');

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'stopBodyScroll': 'ModalContainer__stopBodyScroll___3oNKK',
  'overlayDefault': 'ModalContainer__overlayDefault___1Vj5A',
  'overlayFadeStart': 'ModalContainer__overlayFadeStart___sMsD1',
  'overlayDefaultOpening': 'ModalContainer__overlayDefaultOpening___8a5KA',
  'overlayDefaultClosing': 'ModalContainer__overlayDefaultClosing___3ToWB',
  'modalDefault': 'ModalContainer__modalDefault___2BfP6',
  'modalMedium': 'ModalContainer__modalMedium___yt_fR',
  'modalLarge': 'ModalContainer__modalLarge___1yXsP',
  'modalFullscreen': 'ModalContainer__modalFullscreen___1Un8X',
  'modalHeightCenter': 'ModalContainer__modalHeightCenter___1uOBs'
};

var DefaultModalContainer = (0, _mergeThemeHoc2.default)(style)(_ModalContainer2.default);
DefaultModalContainer.displayName = 'DefaultModalContainer';
exports.default = DefaultModalContainer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-elements/dist/ModalContainer/index.js
// module id = ./node_modules/dibs-elements/dist/ModalContainer/index.js
// module chunks = 4